import { render, staticRenderFns } from "./NlprTable.vue?vue&type=template&id=15687d42"
import script from "./NlprTable.vue?vue&type=script&lang=ts"
export * from "./NlprTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports